import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RefactorRequest } from '../../../core/models/refactor-request';
import { SubmitTaskResponse } from '../../../core/models/submit-task-response';

@Injectable({
  providedIn: 'root'
})
export class RefactorService {
  // Resources
  private refactorResource = 'ms-refactor';
  // URL of service
  private readonly apiRefactor: string;

  constructor(private http: HttpClient) {
    this.apiRefactor = `${environment.refactorApiUrl}`;
  }

  uploadZip(file: File, selectedProjectId: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', selectedProjectId);
    return this.http.post<any>(`${this.apiRefactor}/upload-zip`, formData).pipe(
      tap(response => {
      })
    );
  }

  uploadCode(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(`${this.apiRefactor}/upload-code`, formData).pipe(
      tap(response => {
      })
    );
  }

  //  Method to send the transformed data to demo-refactor
  sendRefactorRequest(token: string, refactorRequest: RefactorRequest): Observable<any> {

    const headers = new HttpHeaders({
      'X-Genai-Bearer': token,
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(`${this.apiRefactor}/refactor/project`, refactorRequest, { headers });
  }

  sendRefactorIndividualFiles(token: string, fileIds: string[], refactorRequest: RefactorRequest): Observable<SubmitTaskResponse> {
    const headers = new HttpHeaders({
      'X-Genai-Bearer': token,
      'Content-Type': 'application/json',
    });
    return this.http.post<SubmitTaskResponse>(`${this.apiRefactor}/refactor/individual-files`, {...refactorRequest, fileIds}, {headers});
  }

  getResultFromCompleted(taskId: string): Observable<any> {
    return this.http.get<any>(`${this.apiRefactor}/tasks/${taskId}/result`);
  }

  stop(taskId: string): Observable<boolean>{
    return this.http.post<boolean>(`${this.apiRefactor}/stop`, {taskId});
  }
}


